module.exports = require("@aws-sdk/client-appconfigdata");